import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import dayjs from "dayjs"

type Props = {
  fieldHandler?: any
  index?: any
  ops?: any
  defaultValue?: any
  disabled?: any
  startDate?: any
  EndDate?: any
  formKey?: any
}

const ReusableDatePicker = (props: Props) => {
  const {
    fieldHandler,
    index,
    ops,
    defaultValue,
    disabled,
    startDate,
    EndDate,
    formKey,
  } = props

  const minDate = formKey == "guarantee_start_date" ? startDate : null
  const maxDate = formKey == "guarantee_end_date" ? EndDate : null

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        sx={{ width: "100%" }}
        onChange={(value: any, sec: any) =>
          fieldHandler(dayjs(value).format("MM-DD-YYYY"), index, ops)
        }
        defaultValue={defaultValue}
        disabled={ops.key == "plan_end_date" ? false : disabled}
        minDate={dayjs(minDate)}
        maxDate={dayjs(maxDate)}
      />
    </LocalizationProvider>
  )
}

export default ReusableDatePicker
